import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";

interface Props {
  tag: string | undefined;
  category: string | undefined;
  rowIndex: number | undefined;
}
/**
 * Custom hook to populate current date or time data into form fields based on specific conditions.
 *
 * @param props - An object containing the following properties:
 *   - tag: A string indicating the type of data to populate (e.g., "autoPopDateTime").
 *   - category: A string representing the CSS class of the target elements.
 *   - rowIndex: The index of the row to target for data population.
 * @returns An object containing the `handlePopulateCurrentData` function to trigger data population.
 */
const usePopulateCurrentData = ({ tag, category, rowIndex }: Props) => {
  const { setValue } = useFormContext();
  /**
   * Populates current date or time data into form fields if conditions are met.
   *
   * @param value - A boolean indicating whether to populate the current data (true) or clear it (false).
   */
  const handlePopulateCurrentData = (value: boolean) => {
    if (tag !== "autoPopDateTime" || !category) return;

    document.querySelectorAll(`.${category}`).forEach(wrapper => {
      if (!wrapper.classList.contains(`rowIndex-${rowIndex}`)) {
        return;
      }

      let inputId: string | null = "";
      let inputType: string | null = "";

      const childWithDataId = wrapper.querySelector("[data-id]");
      if (childWithDataId) {
        inputId = childWithDataId.getAttribute("data-id");
        inputType = childWithDataId.getAttribute("data-unit");
      }
      if (!inputId || !inputType) return;
      let newValue: any = "";
      switch (inputType) {
        case "date":
          newValue = value ? new Date() : null;
          break;
        case "time":
          newValue = {
            time: value ? dayjs().format("HH:mm") : "",
            type: "LT",
          };

          break;
      }
      setValue(inputId, newValue);
    });
  };
  return { handlePopulateCurrentData };
};
export default usePopulateCurrentData;
